import PayPending from '../component/payPending';

export default (props) => {
  return <PayPending {...props} />;
};

export async function getServerSideProps() {
  return {
    props: {
      isDev: process.env.TEST_ENV === 'test',
    },
  };
}
